import React, {type FC} from 'react';
import s from './FiltersSubmitButton.scss';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {useGlobals, withGlobals} from '../../../../../globalPropsContext';
import classNames from 'classnames';

const FiltersSubmitButtonComp: FC<IProvidedTranslationProps> = ({t}) => {
  const {applyFilteredProductsOnMobile, usingExtendedGridGalleryStyles, hasFilters, hasActiveSortOption} = useGlobals();

  const classes = classNames(s.filtersSubmitButton, {
    [s.fullWidthWithFilters]: hasActiveSortOption && hasFilters,
    [s.fullWidthWithoutFilters]: hasActiveSortOption && !hasFilters,
    [s.usingExtendedGridGalleryStyles]: usingExtendedGridGalleryStyles,
  });

  return (
    <button
      type="button"
      className={classes}
      data-hook="filters-submit-button"
      onClick={() => applyFilteredProductsOnMobile()}>
      {t('filtersSubmitButtonText')}
    </button>
  );
};
export const FiltersSubmitButton = withGlobals(withTranslations()(FiltersSubmitButtonComp));
